import { computed, ref } from 'vue'
import {
  getCrmExportSettings,
  putCrmExportEnabled,
  type CrmExportSettings,
} from '../../services/crmExportApi'

const settings = ref<CrmExportSettings | null>(null)
const loaded = ref(false)
let inflight: Promise<void> | null = null

async function refresh(): Promise<void> {
  if (!inflight) {
    inflight = (async () => {
      try {
        settings.value = await getCrmExportSettings()
        loaded.value = true
      } catch (e) {
        console.warn('[useCrmExport] refresh failed', e)
        // Keep the last-known settings; `loaded` stays false on a first-load
        // failure so cards can render a checking state instead of a false "Off".
      } finally {
        inflight = null
      }
    })()
  }
  return inflight
}

// PUT then re-GET: the PUT response is deliberately credit-less.
async function setEnabled(enabled: boolean): Promise<void> {
  try {
    await putCrmExportEnabled(enabled)
  } finally {
    await refresh()
  }
}

const enabled = computed(() => Boolean(settings.value?.crm_export_enabled))
const provider = computed(() => settings.value?.provider ?? null)

export function useCrmExport() {
  return { settings, loaded, enabled, provider, refresh, setEnabled }
}
